module.exports = __webpack_public_path__ + "static/media/1_13.d65234d5.jpg";